let config = {};

config.windowRoot = "https://staging.cycleplanner.betterbybike.info";
config.websiteUrl = "https://staging.betterbybike.info";
config.windowPort = "";

export default config;



// WEBPACK FOOTER //
// ./src/config.js